import { Box } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  settingsContainer: {
    border: "1px solid #e1e1e1",
    borderRadius: 5,
    padding: "5px",
    position: "relative",
  },
}));

const getSettingsFromLayout = layout => ({});

const ProjectKeyResourcesSettings = ({ onWidgetPropertyUpdate, projectId, selectedWidget }) => {
  const classes = useStyles();

  const settings = getSettingsFromLayout(selectedWidget);

  return (
    <Box className={classes.settingsContainer}>
    </Box>
  );
};

export default ProjectKeyResourcesSettings;
